import classNames from 'classnames';
import './index.less';

const TabsSwitch = ({ tabs, activeTab, onChangeTab }) => {
    
    const handleTabClick = (tab) => {
        if (typeof onChangeTab === 'function') {
            onChangeTab(tab);
        }
    }

    return (
        <div className='tabs-switch'>
            {tabs.map((tab) => (
                <span key={tab.id} className={classNames('tab-switch-item', { active: activeTab === tab.id })} onClick={() => handleTabClick(tab)} >
                    {tab.text}
                </span>
            ))}
        </div>
    );
};

export default TabsSwitch;